import styled from "styled-components";

interface MainBoxProps {
  $asideOpen: boolean;
}

export const MainTemplate = styled.div<MainBoxProps>`
  /* display: grid; */
  width: 100%;
  max-width: 45rem;
  height: 100svh;
  transition: all 0.3s ease;
  margin: 0 auto;
`;

export const ContentSection = styled.section`
  overflow: auto;
  grid-area: CT;
  /* background: ${(props) => props.theme.colors.primary5}; */
`;
